import Slider from '../Slider';

export const StepShots = ({ steps, activeIndex, onChangeStep }) => (
  <div className="stepper-carousel">
    <Slider
      swipe={0.2}
      duration="700ms"
      timing="ease"
      step={activeIndex}
      onChangeStep={onChangeStep}
    >
      {steps.map(({ img }, index) => (
        <a
          key={index}
          className="stepper-shot"
          href={img}
          title="Открыть скриншот в полном размере"
        >
          <img src={img} alt={`Шаг ${index + 1}`} />
        </a>
      ))}
    </Slider>
  </div>
);
